/**
 * The surfaces every screen is built from, in the prototype's flat language: 1 px `line` borders,
 * square corners, white on the `surface` background.
 *
 * Plain strings on purpose: a caller appends its own layout classes without a helper, and
 * Tailwind's scanner still sees every literal at build time.
 */

/** A screen below the header: fills the rest of the viewport and scrolls on its own. */
export const SCREEN = 'flex min-h-0 flex-1 overflow-auto';

/** The one card: a full 1 px border, square corners, white. */
export const CARD = 'border border-line bg-white';

/** The card with its own padding, for panels that hold prose or a form rather than a table. */
export const CARD_PADDED = `${CARD} p-6`;

/** The card that floats alone in the middle of a screen (progress, sign-in states). */
export const CARD_FLOATING = `${CARD} shadow-[0_2px_12px_rgba(10,45,80,.06)]`;

/** The small square behind a leading icon. */
export const ICON_TILE = 'flex h-8 w-8 shrink-0 items-center justify-center bg-surface text-muted';

/** The small all-caps label that names a group ("Typy detekce", "Detekované kategorie"). */
export const SECTION_LABEL = 'text-[10.5px] font-semibold uppercase tracking-[.1em] text-label';

/** The heading of a card or panel. */
export const PANEL_TITLE = 'text-[19px] font-bold text-primary';

/** An outlined secondary button: white, `control` border, navy on hover. */
export const BUTTON_OUTLINE =
  'rounded border border-control bg-white font-semibold text-muted hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-50';

/** The filled navy button. */
export const BUTTON_PRIMARY =
  'rounded border-none bg-primary font-semibold text-white hover:bg-primary-deep disabled:cursor-not-allowed disabled:bg-control disabled:text-faint';

/** File drop target, idle. */
export const DROP_ZONE = 'border-2 border-dashed border-[#9fd4ea] bg-wash';

/** The same drop target with a file in it, or while a file is dragged over it. */
export const DROP_ZONE_ACTIVE = 'border-2 border-dashed border-[#c6dcea] bg-white';

/** A read-only tag: a count, a resolved value. Not a control. */
export const CHIP = 'inline-flex items-center bg-surface px-2 py-0.5 text-[11px] font-semibold text-muted';
